import { Navigate, useLocation } from 'react-router-dom';
// Permissions
import useParazol from '../services/parazol/useParazol';

/**
 * Component to protect route from non connected users and if necessary users
 * that don't have access to this route.
 * @param {object} props
 * @param {React.ReactNode} props.children
 * @param {Array<string>} [props.permissions=[]]
 * @returns {React.ReactNode}
 */
export default function ProtectedRoute({ permissions = [], children }) {
  // Hooks
  const location = useLocation();
  const { authContext, hasPermission } = useParazol();

  return authContext.isAuthenticated && (permissions.length ? hasPermission(permissions) : true)
    ? children
    : <Navigate to="/login" state={{ from: location }} replace />;
}
